<template>
    <div class="display-frame">
        <div v-if="!config" class="connect">
            <img src="../../assets/logo.png"/>
            <h3>Connect Display in Director</h3>
            <div class="key">{{displayId}}</div>
        </div>
        <div v-else class="connect">
            <div v-if="!displayComponent">
                <img src="../../assets/logo.png"/>

                <div class="connected-info">
                    <h3><i class="fas fa-check" style="color: green;"></i> Connected to Director</h3>
                    <div class="info">
                        <div class="build-name"><i class="far fa-box-full"></i> {{title}}</div>
                        <div class="display-name"><i class="far fa-tv"></i> {{name}}</div>
                    </div>
                    <b-button variant="primary" size="lg" block @click="start()">Start the Display</b-button>
                </div>

                <b-button variant="link" size="sm" @click="disconnect()"><i class="far fa-times"></i> Disconnect this Display</b-button>
            </div>
            <div v-else>
                <component :is="displayComponent" :message="message" :code="code" :config="config" :room="room"/>
            </div>
        </div>
    </div>
</template>

<script>
    import Kit1Display from "../../kits/1/display.vue";

    const MILLISECONDS_SECOND = 1000;
    const MILLISECONDS_MINUTE = 60 * MILLISECONDS_SECOND;
    const MILLISECONDS_HOUR = 60 * MILLISECONDS_MINUTE;
    const MILLISECONDS_DAY = 24 * MILLISECONDS_HOUR;

    export default {
        name: 'display',
        components: {Kit1Display},
        data: function() {
            return {
                room_id: null,
                code: null,
                name: null,
                displayComponent: null,
                title: null,
                room: null,
                config: null,
                timeout: null
            }
        },
        created: function() {
            this.code = (localStorage.getItem('room_code')) ? localStorage.getItem('room_code') : null;
            this.room_id = (localStorage.getItem('room_id')) ? localStorage.getItem('room_id') : null;
            this.name = (localStorage.getItem('name')) ? localStorage.getItem('name') : null;
            this.next();
        },
        methods: {
            start: function() {
                this.displayComponent = 'kit' + this.room.kit_id + '-display';
            },
            disconnect: function() {
                console.log('Disconnecting Display');
                localStorage.removeItem('room_id');
                localStorage.removeItem('room_code');
                localStorage.removeItem('kit_id');
                localStorage.removeItem('name');

                this.name = null;
                this.room_id = null;
                this.code = null;
                this.config = null;
                this.room = null;
                this.title = null;

                // TODO, this doesn't actually signal the server it is disconnected.  Socket rooms will still have the room code.
            },
            next: function() {
                this.timeout = setTimeout(this.step.bind(this), 10);
            },
            step: function() {
                if (this.room) {
                    if (this.room.status === 'running') {
                        this.room.time = Math.max(0, this.room.finishTime - new Date().getTime());
                    }

                    this.room.hours = pad(Math.floor((this.room.time % MILLISECONDS_DAY) / MILLISECONDS_HOUR), 2);
                    this.room.minutes = pad(Math.floor((this.room.time % MILLISECONDS_HOUR) / MILLISECONDS_MINUTE), 2);

                    let data = ((this.room.time % MILLISECONDS_MINUTE) / MILLISECONDS_SECOND).toFixed(2).split('.');
                    this.room.seconds = pad(data[0],2);
                    this.room.milliseconds = pad(data[1],2);
                }

                this.next();
            }
        },
        computed: {
            displayId: function() {
                return this.$store.state.socket.identity.substr(-4).toUpperCase();
            },
            identity: function () {
                return this.$store.state.socket.identity;
            },
            message: function () {
                return this.$store.state.socket.message;
            }
        },
        watch: {
            identity(identity) {
                console.log('Socket: Setting type as display.');
                console.log('room_code:', this.code);

                this.$socket.sendObj({cmd: 'handshake', data: {type: 'display', room_code: this.code, name: this.name}, identity: identity});
                this.$store.commit('setSocketType', 'display');
            },
            message(payload) {
                switch (payload.cmd) {
                    case 'message':
                        let msg = payload.data;
                        switch (msg.cmd) {
                            case 'connected':
                                console.log('CONNECTED', msg.data);

                                this.name = msg.data.display_name;
                                this.room_id = msg.data.room_id;
                                this.code = msg.data.code;
                                this.room = msg.data;

                                localStorage.setItem('name', this.name);
                                localStorage.setItem('room_id', this.room_id);
                                localStorage.setItem('room_code', this.code);
                                localStorage.setItem('kit_id', msg.data.kit_id);

                                this.$socket.sendObj({cmd: 'handshake', data: {type: 'display', room_code: this.code, name: this.name}, identity: this.identity});

                                break;
                            case 'status':
                                if (this.room.status === 'paused' && msg.data.status === 'running') {
                                    this.room.finishTime = new Date().getTime() + this.room.time;
                                }
                                this.room.status = msg.data.status;
                                break;
                            case 'timer':
                                this.room.time = msg.data.time;
                                this.room.finishTime = new Date().getTime() + msg.data.time;
                                break;
                        }
                        break;
                    case 'room':
                        payload.data.finishTime = new Date().getTime() + payload.data.time;

                        this.room = payload.data;
                        this.title = payload.data.title;
                        this.config = payload.data.config;
                        break;
                }
            }
        }
    }

    function pad(n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }
</script>

<style lang="scss" scoped>
    .display-frame {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;

        background-color: black;
        overflow: hidden;
    }

    .connect {
        padding: 100px;
        text-align: center;

        img {
            margin-bottom: 20px;
        }

        .key {
            margin-top: 20px;
            font-family: "Lucida Console", Monaco, monospace;
            font-size: 150px;
            letter-spacing: 50px;
            text-indent: 50px;
        }

        .connected-info {
            width: 550px;
            margin: 50px auto 0;
            border: 1px solid #333;
            /*border-radius: 15px;*/
            padding: 35px;
            text-align: left;

            h3 {
                i {
                    margin-right: 15px;
                }
                padding-left: 10px;
                border-bottom: 1px solid #222;
                padding-bottom: 20px;
                margin-bottom: 35px;
            }

            .info {
                border-bottom: 1px solid #222;
                padding-bottom: 20px;
                margin-bottom: 35px;

                .display-name, .build-name {
                    padding-left: 10px;
                    i {
                        margin-right: 15px;
                        font-size: 26px;
                        vertical-align: middle;
                    }
                    margin-bottom: 20px;
                }
            }
        }

        .btn.btn-link {
            margin: 50px;

            color: #333;
            &:hover {
                color: #E46A3B;
                text-decoration: none;
            }
            i {
                margin-right: 6px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/display/display.vue